export default __webpack_public_path__ + "418a53decd031c7e0f02c7ad8716f910.svg";